import LFO from 'modulators/LFO.js';
import Tone from 'tone';
import ParameterContext from 'effects/ParameterContext.js';

class LFOTrack {
    constructor(sequencerEngine, lfosTrack, mixSession, number, context) {
        this.store = sequencerEngine.store;
        this.sequencerEngine = sequencerEngine;
        this.context = (context || new ParameterContext)
            .forLFOTrack(this, lfosTrack)
            .forSubSequence(lfosTrack.subSequence);
        this.number = number;
        this.lfo = new LFO(
            sequencerEngine,
            mixSession,
            new ParameterContext().forLFOTrack(this, lfosTrack),
            number);
        this.lfo.lfoMin = -100;
        this.lfo.lfoMax  = 100;
    }

    get id() {
        return this.lfo.id;
    }

    start(time) {
        this.lfo.start(time);
    }

    stop() {
        this.lfo.stop();
    }

    getName() {
        return 'LFO ' + this.number;
    }

    getJson() {
        return this.lfo.getJson();
    }
}

export default LFOTrack;
